var _circle, _circle2, _circle3, _path, _rect, _rect2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDis3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 37,
    r: 7.60163,
    fill: "#61B06F",
    stroke: "#61B06F",
    strokeWidth: 0.796748
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 36,
    r: 2,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 36,
    r: 2,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.285 47.285C80.285 45.3864 77.8152 44.5702 76.0201 43.8473C74.2431 43.1317 71.0991 43.8473 71.0991 43.8473C71.0991 43.8473 67.1387 45.7069 67.1387 47.513C67.1385 54.3886 67.9353 59.3171 67.9356 67.5673C67.9359 75.8175 79.8864 73.7553 79.8866 67.5673C79.8868 61.3793 80.2849 54.1606 80.285 47.285Z",
    fill: "#61B06F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 109.658,
    width: 44.6179,
    height: 14.3415,
    fill: "#535467"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5449,
    y: 96.9102,
    width: 16.7317,
    height: 12.748,
    fill: "#535467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6065 69.9155C68.9405 70.6851 70.6459 70.2276 71.4155 68.8935C72.1851 67.5595 71.7276 65.8542 70.3936 65.0845L67.6065 69.9155ZM68.0669 46.3321C66.0952 47.5455 62.1241 50.7824 60.4871 55.0989C59.6246 57.373 59.3793 60.0497 60.5471 62.7912C61.6908 65.476 64.0338 67.8543 67.6065 69.9155L70.3936 65.0845C67.4663 63.3957 66.1937 61.8154 65.6782 60.6054C65.1869 59.4521 65.2388 58.2977 65.7019 57.0766C66.7159 54.4028 69.5091 51.9933 70.9899 51.082L68.0669 46.3321Z",
    fill: "#61B06F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5485 93.5556C65.4554 95.0929 66.626 96.4146 68.1633 96.5078C69.7006 96.6009 71.0224 95.4302 71.1155 93.893L65.5485 93.5556ZM68.3565 66.6646C67.5628 72.6169 66.3525 80.2901 65.5485 93.5556L71.1155 93.893C71.9051 80.8658 73.0849 73.4008 73.8848 67.4018L68.3565 66.6646Z",
    fill: "#61B06F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2718 93.5556C82.365 95.0929 81.1943 96.4147 79.657 96.5078C78.1197 96.601 76.7979 95.4303 76.7048 93.893L82.2718 93.5556ZM79.4638 67.0631C80.2554 72.9995 81.4676 80.2858 82.2718 93.5556L76.7048 93.893C75.9155 80.8702 74.7375 73.815 73.9355 67.8002L79.4638 67.0631Z",
    fill: "#61B06F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8152 69.1172C81.6459 70.1196 79.8854 69.9842 78.8831 68.8148C77.8808 67.6455 78.0162 65.8851 79.1855 64.8828L82.8152 69.1172ZM79.7542 46.3321C81.5385 47.4301 85.4516 50.1027 87.3833 54.0493C88.3979 56.1222 88.8961 58.611 88.1927 61.3397C87.5005 64.025 85.7275 66.6209 82.8152 69.1172L79.1855 64.8828C81.523 62.8791 82.4681 61.204 82.792 59.9475C83.1047 58.7345 82.9171 57.611 82.3739 56.5012C81.1901 54.0825 78.4995 52.1086 76.8312 51.082L79.7542 46.3321Z",
    fill: "#61B06F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDis3);
export default __webpack_public_path__ + "static/media/dis-3.933ddc1f4391b5aaa69e346db8a88843.svg";
export { ForwardRef as ReactComponent };